var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsultant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.507 57.126c.856 1.976 1.354 4.394 1.464 7.19 2.889.662 5.051 3.246 5.051 6.332 0 3.584-2.916 6.5-6.5 6.5s-6.5-2.916-6.5-6.5c0-3.051 2.115-5.608 4.953-6.307-.125-2.777-.789-7.002-3.507-9.088a26.808 26.808 0 0 0-4.276-.753c-.108 4.865-16.188 16.871-16.188 16.871S33.919 59.367 33.81 54.502a26.394 26.394 0 0 0-4.733.873c-1.983 1.57-3.009 4.495-3.062 8.747a3.29 3.29 0 0 1 1.343 1.491c2.136 1.009 4.023 3.131 5.468 6.152.242.508.274 1.082.096 1.606.866 2.229 1.361 4.665 1.361 6.711 0 2.867 0 5.578-3.125 6.274a1.882 1.882 0 0 1-1.207.436h-2.088a1.902 1.902 0 0 1-1.899-1.898l.002-.074a1.91 1.91 0 0 1 1.897-1.825h2.088a1.9 1.9 0 0 1 .625.106.56.56 0 0 0 .167-.065c.232-.412.232-2.128.232-2.952 0-1.662-.416-3.669-1.145-5.534a2.137 2.137 0 0 1-.872-.933c-1.266-2.651-2.988-4.363-4.386-4.363-1.43 0-3.238 1.852-4.499 4.604a2.166 2.166 0 0 1-1.011 1.033c-.659 1.784-1.021 3.621-1.021 5.192 0 .692 0 2.528.264 2.96.003 0 .062.036.228.077.216-.083.448-.126.68-.126h2.092a1.9 1.9 0 0 1 1.888 1.707l.01.117c0 1.121-.852 1.975-1.898 1.975h-2.092c-.415 0-.816-.139-1.146-.391-1.195-.225-2.037-.752-2.57-1.61-.646-1.037-.764-2.399-.764-4.709 0-2.026.468-4.36 1.318-6.589a2.1 2.1 0 0 1 .125-1.424c.885-1.936 2.011-3.594 3.255-4.793a9.009 9.009 0 0 1 2.188-1.576 3.322 3.322 0 0 1 1.399-1.576c.032-2.665.442-4.966 1.2-6.863C15.54 61.664 9.593 70.667 9.593 81.064 9.593 94.35 19.3 95 32.007 95c1.387 0 2.807-.008 4.258-.008h27.467c1.449 0 2.869.008 4.256.008 12.709 0 22.42-.65 22.42-13.936-.001-10.507-6.075-19.589-14.901-23.938z",
    fill: "#0958d9",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.008 57.992c12.284 0 22.241-18.471 22.241-30.754C72.249 14.957 62.292 5 50.008 5c-12.282 0-22.239 9.957-22.239 22.238 0 12.283 9.957 30.754 22.239 30.754z",
    fill: "#0958d9",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.521,
    cy: 70.648,
    r: 3,
    fill: "#0958d9",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultant);
export default __webpack_public_path__ + "static/media/consultant.ff88b0e3b5150786e5799337c8ac34ed.svg";
export { ForwardRef as ReactComponent };